export default "__VITE_ASSET__r9rnik2B__"